
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/teaching",
      function () {
        return require("private-next-pages/cases/teaching.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cases/teaching"])
      });
    }
  